// SPDX-License-Identifier: AGPL-3.0-or-later

import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import {RoomOutfitModal} from '@app/features/voice_scene/components/RoomOutfitModal';

// The outfit editor, after letting go of the walking camera's pointer lock (the modal needs the cursor).
export function openRoomOutfit(): void {
	if (document.pointerLockElement) document.exitPointerLock();
	ModalCommands.push(ModalCommands.modal(() => <RoomOutfitModal />));
}
